import { forwardRef, ReactNode } from 'react';
import { getAnalyticsProp } from '@cld/analytics';
import { SingleTrigger, Trigger, TriggerProps } from '../../components/Trigger/Trigger';

export const DefaultTriggerButton = forwardRef<HTMLButtonElement, DefaultTriggerButtonProps>(
  ({ isSingle, analyticsMessage, dataTestSpecifier, ...rest }, ref) => {
    const TriggerButton = isSingle ? SingleTrigger : Trigger;
    const analyticsProp = getAnalyticsProp(analyticsMessage);

    return <TriggerButton ref={ref} data-test-specifier={dataTestSpecifier} {...analyticsProp} {...rest} />;
  }
);

export interface DefaultTriggerButtonProps extends TriggerProps {
  isSingle?: boolean;
  children: ReactNode;
  dataTestSpecifier?: string;
  analyticsMessage?: string;
}
